module.exports = __webpack_public_path__ + "static/media/img3.6e56fa72.jpg";